<template>
  <el-form
    class="designer-add-info-c clearfix"
    ref="form"
    :model="form"
    :rules="rules"
    label-width="100px"
    style="margin-top: 30px;"
  >
    <el-form-item label="项目名称" prop="name">
      <el-input size="mini" v-model="form.name" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="业主" prop="company">
      <el-input size="mini" v-model="form.company" placeholder="请输入业主"></el-input>
    </el-form-item>
    <el-form-item label="设计单位" prop="project">
      <el-input size="mini" v-model="form.project" placeholder="请输入设计单位"></el-input>
    </el-form-item>
    <el-form-item label="城市" prop="prov_id">
      <el-select size="mini" v-model="form.prov_id" placeholder="请选择">
        <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="地址" style="width: 100%;" prop="address">
      <el-input size="mini" v-model="form.address" placeholder="请输入地址"></el-input>
    </el-form-item>
    <el-form-item label="项目分类" prop="mold_id">
      <el-select size="mini" v-model="form.mold_id" placeholder="请选择" @change="moldOnChange">
        <el-option v-for="item in molds" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="项目子分类" style="width: 100%;" prop="mold_ids">
      <el-select size="mini" v-model="form.mold_ids" placeholder="请选择" multiple>
        <el-option v-for="item in mold_ids" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="联系电话" prop="phone">
      <el-input size="mini" v-model="form.phone" placeholder="请输入联系电话"></el-input>
    </el-form-item>
    <el-form-item label="项目功能" prop="function">
      <el-input size="mini" v-model="form.function" placeholder="请输入项目功能"></el-input>
    </el-form-item>
    <el-form-item label="项目规模" style="width: 100%;" prop="scale">
      <el-input size="mini" v-model="form.scale" placeholder="请输入项目规模"></el-input>
    </el-form-item>
    <el-form-item label="项目描述" style="width: 100%;margin-top: 8px;" prop="content">
      <el-input size="mini" v-model="form.content" placeholder="请输入项目描述" type="textarea" maxlength="200" show-word-limit></el-input>
    </el-form-item>
    <div style="text-align: center;margin-top: 20px;">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="quxiao">取消</el-button>
    </div>
  </el-form>
</template>

<script>
import { molds } from "@/api/common";
import { mapState } from "vuex";
export default {
  data() {
    let validateF = (rule, value, callback) => {
        if (value.length == 0) {
          callback(new Error("请选择子分类"));
        } else if(value.length > 5){
           callback(new Error("最多选择五个子分类"));
        }else{
          callback();
        }
      };
    return {
      form: {
        company: "",
        project: "",
        name: "",
        address: "",
        store_id: 0,
        mold_ids: []
      },
      mold_ids: [],
      rules: {
        // company: [
        //   { required: true, message: "请输入业主", trigger: "blur" }
        // ],
        // project: [
        //   { required: true, message: "请输入设计单位", trigger: "blur" }
        // ],
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        // address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        // prov_id: [{ required: true, message: "请选择城市", trigger: "change" }],
        // mold_id: [{ required: true, message: "请选择分类", trigger: "change" }],
        // mold_ids: [
        //   { required: true, message: "请选择子分类", trigger: "change", validator: validateF }
        // ],
        phone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          },
          {
            pattern: /^0{0,1}(1)[0-9]{10}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ],
        // function: [
        //   { required: true, message: "请输入项目功能", trigger: "blur" }
        // ],
        // scale: [{ required: true, message: "请输入项目规模", trigger: "blur" }],
        // content: [
        //   { required: true, message: "请输入项目描述", trigger: "blur" }
        // ]
      }
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    fn: {
      type: Function,
      default: function() {}
    },
    successFun: {
      type: Function,
      default: function() {}
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    },
    lyoption: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: mapState({
    molds: state => state.molds,
    cities: state => state.cities
  }),
  watch: {
    molds(val) {
      // this.renderItems.mold_id.options = val;
    },
    cities(val) {
      // this.renderItems.prov_id.options = val;
    }
  },
  created() {
    console.log(this.molds, 898);
  },
  methods: {
    moldOnChange(id) {
      this.$set(this.form, "mold_ids", "");
      this.getChildMolds(id);
    },
    async getChildMolds(id) {
      const res = await molds(id);
      const { list } = res.data;
      this.mold_ids = list;
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.store_id = this.lydata.info.store_id;
          let that = this;

          // that.$layer.closeAll();
          // that.successFun(this.form);
          // return;

          const payCallbackUrl = "html/User/addCallMessage";
          that.$http
            .post(payCallbackUrl, that.form)
            .then(
              () => {
                that.$layer.close(that.layerid);
                that.$layer.closeAll();
                that.successFun(this.form);
              },
              err => {}
            )
            .catch(error => {
              console.log("22222");
            });
        }
      });
    },
    /***
    onSubmit() {
      // const id = this.$layer.iframe({
      //   content: {
      //     content: formComp,
      //     parent: this,
      //     data: { info: this.info }
      //   },
      //   area: ["500px", "300px"],
      //   title: "这是一个标题这是一个标题这是一个标题这是一个标题",
      //   maxmin: true,
      //   shade: true,
      //   shadeClose: false,
      //   scrollbar: false,
      //   resize: true,
      //   cancel: () => {
      //     alert(2110);
      //   }
      // });
      // this.$layer.full(id);
      this.$layer.msg("提交成功", () => {
         console.log('1111');
        this.lydata.info.name = this.form.name;
        // this.$layer.close(this.layerid);
        //this.lyoption.cancel();
        this.fn();
      });
    },
    */
    showmsg() {
      let that = this;
      const phone = this.lydata.info.phone;
      this.$layer.confirm(
        "商户电话:" + phone,
        {
          title: "查看商户电话信息",
          btn: ["确定", "取消"] //按钮
        },
        function() {
          //点击确定访问后台
          that.$layer.closeAll();
        },
        function() {
          //点击取消则中断操作
          that.$layer.closeAll();
          //that.$layer.msg('已取消');
        }
      );
    },
    quxiao() {
      this.fn();
      this.$layer.close(this.layerid);
    }
  },
  mounted() {
    //this.form = this.info;
  }
};
</script>

<style lang="scss">
.designer-add-info-c {
  padding: 0 20px;
  .el-form-item {
    display: inline-block;
    width: 50%;
    margin-bottom: 6px;
  }
  .el-select {
    width: 100%;
  }
  .el-form-item__error {
    padding-top: 0px;
  }
}
</style>
